import { getRequest } from '../services/requestHandler';
import { PutterNeckForSaveDto } from '../models';

export const getPutterNecks = async () => {
  const url = 'putter/getPutterNecks?activeOnly=true&useCache=false';
  const response = await getRequest<PutterNeckForSaveDto>('GetPutterNecks', url);
  return response;
};
